import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Action, GET, GETWITH, If, IfElse, JSX, JSXMap, QueryDetail, QueryOrder, QueryParam, READWITH, errorCatch, useAuth, useMetaContext, useTranslateContext, useUserConfigContext, useUserContext } from 'fennec-ui';
import { useDispatch } from 'react-redux';

import dayjs from 'dayjs'
import 'dayjs/locale/ru'
import { AutomationContext, TestingContext, useNearestObjectContext } from '../../../common/Context';
import PageLayout from '../../components/PageLayout';
import uuid from 'react-uuid';
import Question from './Question';
import { Badge, Button, Dropdown, Form, Menu, Radio, Slider, Space, Tabs, Timeline } from 'antd';
import { answersClearAll, funcClient } from '../../../common/Tool';
import Icofont from 'react-icofont';
var isBetween = require('dayjs/plugin/isBetween')
var utc = require('dayjs/plugin/utc')
var timezone = require('dayjs/plugin/timezone') // dependent on utc plugin
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(isBetween)
dayjs.locale('ru');

var _ = require('lodash');

export function Service(props) {
	let { service } = props;
	const dispatch = useDispatch();
	let navigate = useNavigate();
	const auth = useAuth();
	const t = useTranslateContext();
	const user = useUserContext();
	const meta = useMetaContext();
	const [userConfig, setUserConfig] = useUserConfigContext();
	// const langSwitch = useLangSwitchContext();

	const [questions, setQuestions] = useState();
	const [fsm, setFsm] = useState();
	const [funcs, setFuncs] = useState([]);
	const [loading, setLoading] = useState(false);

	const [context, setContextObject] = useNearestObjectContext()

	useEffect(() => {
		if (context && service) {
			GETWITH(auth, `/api/fsm/context/state/context/${context.ID}/service/${service.ID}`, [
				QueryDetail("model")
			], ({ data }) => {
				setFsm(data);
			}, errorCatch);
			READWITH(auth, "FsmQuestionsServices",
				[
					QueryDetail("model"),
					QueryParam("w-service.ID", service.ID),
					QueryOrder("sorting", "ASC")
				],
				({ data }) => {
					console.log(data);
					const filter = (e) => {
						let f = context.contextAnswerContext.filter(a => a.questionID === e.questionID);
						if (f && f.length == 0) {
							return undefined
						}
						return f;
					};
					let tmp = data.map(e => ({
						...e,
						answer: (e.question.answerTypeID !== 9) ? context.contextAnswerContext.reverse().find(a => a.questionID === e.questionID) : filter(e)
					}))
					let q = tmp.filter(e => e.answer);
					setQuestions(q)
				},
				errorCatch
			);
		}
	}, [context, service]);

	useEffect(() => {
		if (fsm) {
			let allfuncs = _.get(fsm, "currentState.fsmSchemeCurrentState");
			if (allfuncs) {
				let fun = allfuncs.filter(e => e.fsmFunction.isClient === true);
				setFuncs(fun);
			}
		}
	}, [fsm]);

	const onQuestionChange = (fsm) => {
		setFsm(fsm);
		setContextObject(fsm.context);
	};
	const isDone = (context) => {
		return fsm && fsm.currentState.terminal == true;
	};

	const actionFunc = React.useMemo(() => (values, unlock, close, properties) => {
		let func = funcs.find(e => e.fsmFunctionID === values.functions.id)
		if (!isDone(context) && func) {
			funcClient(auth, context, service.ID, values.functions.id, func.question, Object.values(values.question), onQuestionChange, {
				lock: () => setLoading(true),
				unlock: () => {
					unlock();
					setLoading(false)
				},
			});
		}
	}, [context, service, funcs]);
	const funcsWithMaxQuestion = (funcs) => {
		let s = _.maxBy(funcs, function (e) { return e.fsmFunction.questionID; })
		if (s) {
			return s.fsmFunction.ID
		}
	};
	const steps = React.useMemo(() => ([
		{
			key: "functions",
			name: "Шаг 1",
			action: (values, unlock, close) => {
				close(values);
			},
			form: (props) => {
				const { auth, form } = props;
				return <div>
					<Form
						form={form}
						onFinish={props.submit}
						labelAlign={"left"}
						layout={"vertical"}
						initialValues={{
							id: funcsWithMaxQuestion(funcs)
						}}
					>
						{fsm && <div style={{ paddingBottom: "10px" }}>
							<span className="state-description">{fsm.currentState.description}</span>
						</div>}
						<div style={{ paddingBottom: "5px" }}>Возможные действия:</div>
						<Form.Item
							name="id"
							rules={[{ required: true, message: 'Пожалуйста, укажите значение!' }]}
						>
							<Radio.Group size='large'>
								<Space direction="vertical">
									{JSXMap(funcs, (e, idx) => (
										<Radio key={idx} style={{ fontSize: "18px" }} value={e.fsmFunction.ID}>{e.fsmFunction.description}</Radio>
									))}
								</Space>
							</Radio.Group>
						</Form.Item>
					</Form>
				</div>
			},
		},
		{
			key: "question",
			name: "Шаг 2",
			form: (props) => {
				return <Question auth={props.auth} form={props.form} submit={props.submit} fun={funcs.find(e => e.fsmFunctionID === props.data.functions.id)} context={context} onQuestionChange={onQuestionChange} service={service} />
			},
		}
	]), [funcs, fsm]);

	const backFsm = () => {
		if (context && service) {
			GET(auth, `/api/fsm/context/state/back/context/${context.ID}/service/${service.ID}`,
				({ data }) => {
					setFsm(data);
					setContextObject(data.context);
				},
				errorCatch
			);
		}
	};

	const funcUi = (fsm, func) => {
		return (<Action
			mode={"inline"}
			auth={auth}
			okText="Далее"

			fun={func}
			context={context}
			onQuestionChange={onQuestionChange}
			key={(fsm) ? fsm.ID : uuid()}
			form={Question}
			footerExtendedButtons={({ DismissFunction: cancel, OkFunction: ok, mode, loading }) => {
				if (mode === "inline" && !cancel) {
					return [
						{
							key: "backFsm",
							name: 'Назад',
							callback: backFsm,
							options: {
								type: "ghost"
							}
						}
					]
				}
				return []
			}}
			action={(values, unlock, close, properties) => {
				if (!isDone(context)) {
					funcClient(auth, context, service.ID, _.get(func, "fsmFunction.ID"), _.get(func, "fsmFunction.question"), Object.values(values), onQuestionChange, {
						lock: () => setLoading(true),
						unlock: () => {
							unlock();
							setLoading(false)
						},
					});
				}
			}}
		/>)
	}
	return (
		<div>
			<div>
				{If(funcs.length == 1, funcUi(fsm, _.get(funcs, "[0]")))}
				{If(funcs.length > 1, (<div>
					<div>
						{IfElse(false,
							(<Action
								mode={"inline"}
								auth={auth}
								okText="Далее"
								action={actionFunc}
								steps={steps}
								key={(fsm) ? fsm.ID : uuid()}
								footerExtendedButtons={({ DismissFunction: cancel, OkFunction: ok, mode, loading }) => {
									if (mode === "inline" && !cancel) {
										return [
											{
												key: "backFsm",
												name: 'Назад',
												callback: backFsm,
												options: {
													type: "ghost"
												}
											}
										]
									}
									return []
								}}
							/>),
							(<Tabs
								tabPosition={"left"}
								items={funcs.map((e, i) => {
									return {
										// label: e?.fsmFunction?.question?.title,
										label: (<div style={{ lineHeight: "16px" }}>
											<div>{e?.fsmFunction?.question?.title}</div>
											<div style={{ fontSize: "11px", color: "grey", display: "flex", justifyContent: "space-between", gap: "3px" }}>
												<div style={{ flex: "0 0" }}><Badge dot={true} color='#87d068' style={{
													minWidth: "8px",
													width: "8px",
													height: "8px"
												}}></Badge></div>
												{/* <div style={{ flex: "1 1 auto" }}>1 {declOfNum(1, ['балл', 'балла', 'баллов'])}</div> */}
											</div>
										</div>),
										key: e?.fsmFunction?.question?.ID,
										children: funcUi(fsm, e),
									};
								})}
							/>))}
					</div>
				</div>))}
			</div>
			{isDone(context) &&
				<div>
					<div style={{ fontSize: "18px", paddingBottom: "35px" }}>
						<div style={{ fontSize: "24px", fontWeight: "600", color: "green" }}>Готово!</div>
						<div>Все необходимые параметры для подбора сортов и гибридов определены. </div>
						<div>Теперь можно выполнить подбор сорта и просмотреть отчет.</div>
					</div>
					<div style={{ display: "flex", justifyContent: "start", gap: "10px" }}>
						{(fsm && fsm.prevStateID) && <Button size='large' type='default' onClick={backFsm}>
							Назад
						</Button>}
						<Button size='large' type='primary'>
							<Link to={"done"}>Подбор сорта</Link>
						</Button>
					</div>
				</div>
			}
			{(context && context.contextAnswerContext && context.contextAnswerContext.length > 0) &&
                <div>
                    <div style={{ paddingBottom: "15px" }}>
                        <Dropdown trigger={['click']} overlay={<Menu>
                            <Menu.Item onClick={backFsm}>
                                <Icofont icon="simple-left" /> Шаг назад
                            </Menu.Item>
                            <Menu.Divider />
                            <Menu.Item onClick={() => {
                                answersClearAll(auth, context, setContextObject);
                            }}>
                                <Icofont icon="trash" /> Очистить контекст
                            </Menu.Item>
                        </Menu>}>
                            <Button type='text'>
                                <span className="ant-dropdown-link">Действия <Icofont icon="simple-down" /></span>
                            </Button>
                        </Dropdown>
                    </div>
                    <div>
                        <Timeline>
                            {(context && questions) && JSXMap(questions, (e, idx) => (
                                <Timeline.Item key={idx} color={(funcs.findIndex(s => s.fsmFunction.questionID === e.question.ID) < 0) ? "green" : "red"}>
                                    <p style={{ marginBottom: "0em", color: "#aaa", fontStyle: "italic", fontSize: "13px" }}>
                                        {_.get(e, "question.shortTitle") || _.get(e, "question.title")}
                                    </p>
                                    {(e.answer && e.question.answerTypeID !== 9) &&
                                        <p style={{ marginBottom: "0em" }}>{e.answer.answerDisplay}</p>
                                    }
                                    {(e.answer && e.question.answerTypeID === 9) &&
                                        <Timeline style={{ paddingTop: "10px" }}>
                                            {JSXMap(e.answer, (a, idx) =>
                                                <Timeline.Item key={idx} className="small-timeline-dot" color="#378705">
                                                    <div style={{ marginBottom: "0em" }}>
                                                        <div style={{ marginBottom: "0em", fontStyle: "italic", fontSize: "13px" }}>
                                                            {a.answerName}:
                                                        </div>
                                                        <div>{a.answerDisplay}</div>
                                                    </div>
                                                </Timeline.Item>
                                            )}
                                        </Timeline>
                                    }
                                </Timeline.Item>
                            ))}
                        </Timeline>
                    </div>
                </div>}
		</div>
	);
}

export default function Automation(props) {
	let { id } = useParams();
	const dispatch = useDispatch();
	let navigate = useNavigate();
	const auth = useAuth();
	const t = useTranslateContext();
	const user = useUserContext();
	const meta = useMetaContext();
	const [userConfig, setUserConfig] = useUserConfigContext();
	// const langSwitch = useLangSwitchContext();

	// const [service, setService] = useState();
	const [services, setServices] = useState();

	const [context, setContextObject] = useNearestObjectContext()

	useEffect(() => {
		// GET(auth, "/api/context/new",
		//     (res) => setContextObject(res.data),
		//     errorCatch
		// );
		// GET(auth, "/api/context/last",
		// 	(res) => setContextObject(res.data),
		// 	errorCatch
		// );
		READWITH(auth, "FsmServices",
			[
				QueryDetail("model"),
				QueryParam("w-ID", id)
			],
			({ data }) => {
				// console.log(data);
				setServices(data)
			},
			errorCatch
		);
	}, []);

	return (
		<AutomationContext.Provider value={context}>
			<PageLayout hideSider={true} /*hideBreadcrumbs={true}*/>
				<div style={{ backgroundColor: "white", borderRadius: "4px" }}>
					<div style={{ padding: "10px" }}>
						<div>
							{JSXMap(services, (item, index) => (
								<div key={index}>
									<div>
										{item?.name}
									</div>
									<Service service={item} />
								</div>
							))}
						</div>
					</div>
				</div>
			</PageLayout>

			{/* <MenuLevelTwoContext.Provider value={menu(status, notify)}>
                {(!siteAccess || siteAccess == "allow") && <Routes>
                    {defaultRoute(menu(status, notify), role_by_id)}
                    {menu(status, notify).map((e, idx) => {
                        if (e.component && access(e, role_by_id)) {
                            return <Route key={e.uuid} path={(e.uuid !== "*")?e.uuid + "/*":"*"} element={
                                <BreadcrumbsProvider value={{
                                    // parent: props?.level,
                                    uuid: e?.uuid,
                                    name: e?.name,
                                    color: e?.color,
                                    role: e?.role,
                                    hidden: e.hidden
                                }}>
                                    {e.component({})}
                                </BreadcrumbsProvider>}
                            />
                        }
                    })}
                </Routes>}
            </MenuLevelTwoContext.Provider> */}
		</AutomationContext.Provider>
	);
}
